// extracted by mini-css-extract-plugin
export default {"page":"login-page_page__94RV3"};